module.exports = __webpack_public_path__ + "static/media/07-1.30a30928.png";